// Libs
import { useMemo } from 'react';

const useMessageBanner = ({ className, type }) => {
  const classNames = useMemo(
    () =>
      ['message-banner', `message-banner--${type}`, className]
        .filter((val) => val)
        .join(' '),
    [className, type],
  );

  return {
    classNames,
  };
};

export default useMessageBanner;
